import { useTranslation } from 'react-i18next';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import printer from '@assets/animations/printer.lottie';
import ModalDialog from '@components/ui/ModalDialog.component.jsx';

function PrinterDialog({
  open,
  onClose,
  onButtonClick,
  onSecondaryButtonClick,
}) {
  const { t } = useTranslation();
  return (
    <ModalDialog
      variant={'dark'}
      title={t('printer.printConfirm.title')}
      open={open}
      onClose={onClose}
      buttonText={t('common.scanAgain')}
      onButtonClick={onButtonClick}
      secondaryButtonText={t('common.close')}
      onSecondaryButtonClick={onSecondaryButtonClick}
    >
      <DotLottieReact src={printer} loop autoplay />
      <div className="text-center text-base py-2 break-words overflow-hidden">
        {t('printer.printConfirm.description')}
      </div>
    </ModalDialog>
  );
}

PrinterDialog.propTypes = {};
export default PrinterDialog;
